import { useIntl } from 'react-intl';

import * as i18n from '@/helpers/i18n';

export default function useFormatMessage() {
  const { formatMessage } = useIntl();

  return (id, values) => formatMessage({ id }, { ...i18n.elements, ...values });
}
